import LegacyNavDropdown from '@groovepages/gd-ui-kit/components/NavDropdown';
import { createNavDropdownAdapter } from '../../../groove-ui-kit-v2/src/vue2/account-adapter';
export default createNavDropdownAdapter(LegacyNavDropdown);
